import { Link } from "@/i18n/routing";
import { IconMenuLinkArrow } from "@repo/assets/images";
const PopularItems = ({
  items,
  onClick
}) => {
  return <ul className="divide-miniSearch-border divide-y" data-sentry-component="PopularItems" data-sentry-source-file="PopularItems.jsx">
      {items?.map(popularItems => <li className="text-miniSearch-text hover:bg-miniSearch-activeBg px-2 text-sm" key={popularItems.id}>
          <Link href={`/${popularItems.action.type === "plp" ? "collections/" : ""}${popularItems?.action.urlSlug}`} onClick={onClick} className="group flex items-center py-2 font-medium">
            {popularItems.name}
            <span className="ms-auto px-1">
              <IconMenuLinkArrow className="text-miniSearch-icon me-2 -rotate-45 transition-transform group-hover:-translate-y-1 ltr:group-hover:translate-x-1 rtl:rotate-[-135deg] rtl:group-hover:-translate-x-1" />
            </span>
          </Link>
        </li>)}
    </ul>;
};
export default PopularItems;